module.exports = __webpack_public_path__ + "img/guardar.0ccafc44.png";